import {
  AlertCircle,
  Check,
  Maximize2,
  ArrowUpRight,
  Crop,
  Paintbrush,
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useCreateModel } from './context'

const ICON_MAP: Record<string, React.ReactNode> = {
  'maximize-2': <Maximize2 className="h-3.5 w-3.5" />,
  'arrow-up-right': <ArrowUpRight className="h-3.5 w-3.5" />,
  crop: <Crop className="h-3.5 w-3.5" />,
  paintbrush: <Paintbrush className="h-3.5 w-3.5" />,
  check: <Check className="h-3.5 w-3.5" />,
}

export function ValidationWarnings() {
  const { validationWarnings } = useCreateModel()
  if (validationWarnings.length === 0) return null

  const handleApplyAll = () => {
    for (const warning of validationWarnings) {
      // Call the first action's handler for each warning
      warning.actions[warning.actions.length - 1]?.handler()
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm font-medium text-foreground">Uploaded files</p>

      {validationWarnings.map((warning, i) => (
        <div
          key={i}
          className="flex items-center gap-3 rounded-lg border border-border bg-background px-4 py-2.5"
        >
          <AlertCircle className="h-4 w-4 shrink-0 text-destructive" />
          <p className="flex-1 text-sm text-foreground">{warning.message}</p>
          <div className="flex items-center gap-2">
            {warning.actions.map((action) => (
              <Button
                key={action.label}
                variant="outline"
                size="sm"
                onClick={action.handler}
                className="gap-1.5"
              >
                {ICON_MAP[action.iconName]}
                {action.label}
              </Button>
            ))}
          </div>
        </div>
      ))}

      {validationWarnings.length > 1 && (
        <div>
          <Button size="sm" className="gap-1.5" onClick={handleApplyAll}>
            <Check className="h-3.5 w-3.5" />
            Apply all fixes
          </Button>
        </div>
      )}
    </div>
  )
}
